export const TEMPLATE_EVENT_ID = '1d1e054f-ab89-450e-831d-6e84a0458ba5';
